
import { Pipe, PipeTransform } from '@angular/core';
import { capitalizeFirst } from '../../../utils/helper';

export { capitalizeFirst };

@Pipe({
    name: 'capitalizeFirst'
})
export class CapitalizeFirstLetterPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return capitalizeFirst(value);
    }
}